import GenericService from './genericService';
import axiosInstance from '../utils/axios';

class StockAdjustmentService extends GenericService {
  constructor() {
    super('/stock_adjustments', axiosInstance);
  }
}

export default new StockAdjustmentService();
